// ============================================================
// SEGUIMIENTO VSANA — página wrapper
// ============================================================
import React from 'react';
import SeguimientoVsana from '../components/SeguimientoVsana';

const SeguimientoVsanaPage: React.FC = () => {
    return <SeguimientoVsana />;
};

export default SeguimientoVsanaPage;
